import { t } from 'i18next';

type PriceFormatOptions = {
    maximumFractionDigits?: number;
    signDisplay?: 'auto' | 'always' | 'never' | 'exceptZero' | 'accounting';
};

export function formatPrice(
    value: number,
    currency: string,
    { maximumFractionDigits = 0, signDisplay = 'auto' }: PriceFormatOptions
) {
    return t(`{{val, currency(${currency})}}`, {
        val: value,
        formatParams: {
            val: {
                maximumFractionDigits,
                signDisplay,
            },
        },
    });
}
